import { SelectList } from '@acies/core';
import { ComponentCO2Link } from '@acies/domain';
import ComponentCO2LinkItemRenderer from './component-co2link-item-renderer';

export class ComponentCO2LinkList extends SelectList<ComponentCO2Link> {
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.paddingHorizontal = 0;
		this.paddingVertical = 0;
		this.gapVertical = 0;
		this.ItemRenderer = ComponentCO2LinkItemRenderer;
	}
}

customElements.define('ac-component-co2-link-list', ComponentCO2LinkList);
